import { useState } from "react";
import { Animate, Icon } from "components/lib";

type Props = {
  title: string;
  children?: React.ReactNode;
  className?: string;
};

export function DropCard({ title, className, children }: Props) {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="border-b border-black flex flex-col justify-between p-4 rounded-[5px] transition-all duration-150 ease-in-out h-auto">
      <button
        type="button"
        className="cursor-pointer flex justify-between items-center w-full text-white font-bold text-lg"
        onClick={() => setShowAll(!showAll)}
        aria-expanded={showAll}
        aria-controls={`dropCardContent-${title}`}
      >
        {title}
        {showAll ? (
          <Icon image="chevron-up" size={20} />
        ) : (
          <Icon image="chevron-down" size={20} />
        )}
      </button>
      {showAll && (
        <div id={`dropCardContent-${title}`}>
          <Animate type="slidedown">
            <div className={className}>{children}</div>
          </Animate>
        </div>
      )}
    </div>
  );
}
